export const useCasesList = [
  { icon: "📅", label: "Appointments" },
  { icon: "💊", label: "Meds" },
  { icon: "💧", label: "Hydration" },
  { icon: "🏋️", label: "Workouts" },
  { icon: "🛒", label: "Groceries" },
  { icon: "🎂", label: "Birthdays" },
  { icon: "💸", label: "Bill Pay" },
  { icon: "🧘", label: "Meditate" },
  { icon: "⏰", label: "Timers" },
  { icon: "📚", label: "Reading" },
  { icon: "🔌", label: "Unplug" },
  { icon: "🪴", label: "Water Plants" },
  { icon: "🧖‍♀️", label: "Skincare" },
  { icon: "🗑️", label: "Take out Trash" },
  { icon: "🅿️", label: "Move Car" },
  { icon: "📞", label: "Call Mom" },
];

export const testimonials = [
  {
    name: "Hazel Morrison",
    role: "CEO",
    img: "/hazel-img.png",
    frontText:
      "I used to have 5 different apps for todos. Now I just text the assistant. It feels like magic because it's where I already am.",
    before:
      "Juggling 3 calendars, missed dentist appointments, sticky notes everywhere.",
    after: "One WhatsApp chat. 'Remind me' -> Done. Zero mental clutter.",
  },
  {
    name: "Aniket Kumar",
    role: "Product Manager",
    img: "/aniket-img.png",
    frontText:
      "The voice note feature is a lifesaver while driving between meetings. It captures everything accurately.",
    before:
      "Great ideas lost while driving. Forgetting to send follow-up emails.",
    after:
      "Voice note sent at 60mph. Tasks scheduled before I even park the car.",
  },
  {
    name: "Pinupa Pavansai",
    role: "Software Engineer",
    img: "/pinupa-img2.png",
    frontText:
      "Finally, an AI assistant that actually reduces my mental load instead of adding another tool to manage. It's indispensable.",
    before:
      "Mental load overload. 'Did I pay the bill? Did I RSVP?' Constant anxiety.",
    after:
      "The assistant remembers for me. I sleep better knowing nothing is slipping through cracks.",
  },
];

export const rotatingWords = [
  "a thing",
  "meetings",
  "follow-ups",
  "deadlines",
  "birthdays",
  "medicines",
];
